import Url from 'urljs';
import {deserialize} from "deserialize-json-api";
import Paginator from 'headless-pagination';

window.addEventListener('DOMContentLoaded', function () {
    const pagination = document.querySelector("nav.adverts-pagination");

    if (!pagination) return;

    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    const paginationList = pagination.querySelector('ul');
    const pageItemStart = document.querySelector("#page-item-start");
    const pageItemEnd = document.querySelector("#page-item-end");
    const resultsContainer = document.querySelector("#adverts-container");
    const loader = document.querySelector(".loader-overlay");
    const sortDropdown = document.querySelector("#adverts-sort-dropdown");

    let sort = price ? 'price-desc' : "first-seen-at";

    const advertsBlock = document.querySelector("#adverts-block");
    const headerOffset = 90;
    const elementPosition = advertsBlock.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    const params = Url.parseQuery();
    const paginator = new Paginator({
        totalItems: window.total,
        initialPage: +params.page || 1,
        perPage: window.pageSize,
        maxLinks: 7,
    });

    renderPagination(paginator.links());

    // handle browser back/forward buttons
    window.addEventListener('popstate', function (event) {
        const page = +(Url.parseQuery().page || 1);
        paginator.setPage(page);
        renderPagination(paginator.links());
        fetchAndRenderAdverts(page, false);
    }, false);

    function renderPagination(links) {
        paginationList.innerHTML = '';
        const url = location.href.replace(location.search, '');
        const prevBtn = document.createElement('li');
        const prevLink = document.createElement('a');
        const nextBtn = document.createElement('li');
        const nextLink = document.createElement('a');

        prevLink.href = `${url}${paginator.page() < 3 ? '' : '?page=' + (paginator.page() - 1)}`;
        prevLink.innerHTML = '«';
        nextLink.href = `${url}?page=${paginator.page() === paginator.totalPages() ? paginator.totalPages() : paginator.page() + 1}`;
        nextLink.innerHTML = '»';

        if (window.total > 1) {
            pageItemStart.innerHTML = (((paginator.page() - 1) * window.pageSize) + 1).toString();
            const pageItemEndIndex = ((paginator.page() - 1) * window.pageSize) + window.pageSize;
            pageItemEnd.innerHTML = (pageItemEndIndex > window.total ? window.total : pageItemEndIndex).toString();
        } else {
            document.querySelector('#pagination-info').innerHTML = "0 of 0 car";
        }

        if (paginator.page() === 1 || window.total < 1) prevBtn.classList.add('disabled');
        if (paginator.page() === paginator.totalPages()) nextBtn.classList.add('disabled');

        prevBtn.appendChild(prevLink);
        nextBtn.appendChild(nextLink);

        prevLink.addEventListener('click', (e) => {
            e.preventDefault();
            paginator.onPrevious();
            renderPagination(paginator.links());
            fetchAndRenderAdverts(paginator.page());
        });
        nextLink.addEventListener('click', (e) => {
            e.preventDefault();
            paginator.onNext();
            renderPagination(paginator.links());
            fetchAndRenderAdverts(paginator.page());
        });

        paginationList.appendChild(prevBtn);

        links.forEach(i => {
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.innerHTML = i.label.toString();
            link.href = `${url}${+i.label === 1 ? '' : '?page=' + i.label}`

            if (i.active && typeof i.label === "number")
                item.classList.add('selected');

            if (i.disabled)
                item.classList.add('disabled');

            link.addEventListener('click', (e) => {
                e.preventDefault();

                if (typeof i.label === "number" && paginator.page() !== i.label) {
                    paginator.setPage(+i.label);
                    renderPagination(paginator.links());
                    fetchAndRenderAdverts(+i.label);
                }
            });

            item.appendChild(link);
            paginationList.appendChild(item);
        });

        paginationList.appendChild(nextBtn);
    }

    function fetchAndRenderAdverts(pageNumber, updateParams = true) {
        loader.classList.toggle('d-none');

        fetchAdverts(
            window.make,
            window.model,
            window.colour,
            window.currentLocation,
            window.price,
            pageNumber,
            sort
        ).then(({data, meta}) => {
            resultsContainer.innerHTML = "";
            data.forEach(ad => {
                resultsContainer.innerHTML += createAdvertCard(ad);
            });

            if (updateParams) {
                if (pageNumber === 1) {
                    Url.removeQuery(true);
                } else {
                    Url.updateSearchParam("page", pageNumber, true);
                }
            }

            window.scrollTo({top: offsetPosition, behavior: "smooth"});
            loader.classList.toggle('d-none');
        }).catch(() => {
            loader.classList.toggle('d-none');
            alert('Error loading adverts!')
        });
    }


    document.querySelector('#edit-filters-btn')?.addEventListener('click', () => {
        if (window.setModalShown) { // react app already injected
            window.setModalShown(true);
            return;
        }

        window.filterDialogCss.forEach(url => {
            const filterDialogStyles = document.createElement('link');
            filterDialogStyles.type = 'text/css';
            filterDialogStyles.rel = 'stylesheet';
            filterDialogStyles.href = url;
            document.head.append(filterDialogStyles);
        });

        window.filterDialogJs.forEach(url => {
            const script = document.createElement('script');
            script.src = url;
            document.body.appendChild(script);
        });
    });

    sortDropdown.addEventListener('change', (e) => {
        sort = e.target.value;
        renderPagination(paginator.links());
        fetchAndRenderAdverts(paginator.page());
    })
});


const token = window.apiToken;
const API_URL = "https://choosemycar.com/api";

async function fetchAdverts(make = null,
                            model = null,
                            colour = null,
                            location = null,
                            price = null,
                            page = 1,
                            sort = "first-seen-at") {
    let params = [];

    if (make) params.push(`filter[make]='${make.replace(/'/g, "\\'")}'`);
    if (model) params.push(`filter[model]='${model.replace(/'/g, "\\'")}'`);
    if (colour) params.push(`filter[colour]='${colour}'`);
    if (location) params.push(`filter[geo.location]='${location}'`);
    if (price) params.push(`filter[price][lte]=${price}`);


    params.push(`page[number]=${page}`);
    params.push(`page[size]=${window.pageSize}`);
    params.push(`sort=${sort === 'price-desc' ? '-price' : sort}`);
    params.push(`filter[last-seen-at][gte]='-3 days'`);

    let filteredAdverts = deserialize(
        await (
            await (async (endpoint, method = "GET") => {
                return await fetch(`${API_URL}${endpoint}`, {
                    method: method,
                    headers: {
                        'Accept': 'application/vnd.api+json',
                        'Content-Type': 'application/vnd.api+json',
                        'Authorization': 'Bearer ' + token,
                    }
                });
            })(`/adverts/search?${params.join('&')}`))
            .json()
    )
    filteredAdverts.data = filteredAdverts?.data?.filter(i => i.dealer.enabled);
    return filteredAdverts;
}

function range(start, end) {
    return Array.from({length: end - start + 1}, (_, i) => start + i);
}

function createAdvertCard(advert) {
    window['advert-' + advert.id] = {
        id: advert.id,
        make: advert.make.name,
        model: advert.model.name,
        variant: advert.variant.name,
        image: advert.image.smallMedium,
        price: advert.price,
        mileage: advert.mileage,
        year: advert.year,
        lowestMonthlyFinanceFrom: advert.lowestMonthlyFinanceFrom,
    };

    return `
        <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <a href="/vehicle/${advert.id}" class="vehicle-card mx-n2 mx-md-0">
            <div class="vehicle-card-img position-relative splide" style="visibility: visible" data-advert-id="${advert.id}" data-image-count="${advert.imagesCount}">
                  <div class="splide__track">
                    <ul class="splide__list mb-0 pl-0">
                        <li class="splide__slide" style="min-width: 100%">
                            <img src="${advert.image.medium}" alt="${advert.make.name + ' ' + advert.model.name}" loading="lazy">
                        </li>
                        ${advert.imagesCount > 1 ? range(1, advert.imagesCount - 2).map(() => (`
                           <li class="splide__slide" style="min-width: 100%">
                            <div class="advert-image-wrapper">
                                <img src="" alt="" onload="this.classList.add('loaded')" loading="lazy">
                            </div>
                           </li>
                        `)) : ""}
                    </ul>
                  </div>
                  
                  ${advert.imagesCount > 1 ? `
                    <div class="prev-next-btns d-flex justify-content-between d-none d-md-flex">
                       <button class="splide-prev">
                          <svg style="fill: none;" width="26" height="46" viewbox="0 0 26 46" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 43L23 23L3 3" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      </button>
                      <button class="splide-next">
                       <svg style="fill: none;" width="26" height="46" viewbox="0 0 26 46" fill="none"
                              xmlns="h  ttp://www.w3.org/2000/svg">
                              <path d="M3 43L23 23L3 3" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                      </button>
                    </div>
                  ` : ""}
                 <div class="splide_pagination_wrapper d-flex tmp_pagination">
                    <ul class="slider-nav-dots d-flex justify-content-center">
                        ${advert.imagesCount > 1 ? range(1, advert.imagesCount - 1).map((i) => (`
                            <li>
                               <button class="${i === 0 ? 'is-active' : ''}"></button>
                            </li>
                        `)) : ""}
                    </ul>
                 </div>
            </div>
            <div class="vehicle-info">
                    <div class="w-100 d-flex justify-content-between align-items-start gap-3">
                        <h4 class="vehicle-name mb-1"><span>${advert.variant.name}</span> ${advert.make.name} ${advert.model.name}</h4>
                        <button class="advert-card-add-to-wishlist-btn ga_add_to_wish_list" data-advert-id="${advert.id}" data-bs-toggle="modal"
                                data-bs-target="#wishListDialog">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor"
                                style="width: 1.5rem; height: 1.5rem;pointer-events: none">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"></path>
                            </svg>
                        </button>
                    </div>
                    
                    <div class="mt-2 d-flex gap-1 vehicle-specs">
                        <span class="d-inline-block">${formatNumber(advert.mileage)} miles</span>
                        <span class="d-inline-block">${advert.year}</span>
                        <span class="d-inline-block" style="font-size: 12px;background-color:rgba(0, 182, 122, 0.1)">Zero Deposit</span>
                    </div>
                </div>
    
                <div class="d-flex flex-column" style="padding:0 .75rem">
                    <p class="mb-1 mt-1" style="color: #215869;font-size: 12px">Home Delivery Available</p>
                    <div class="prices">
                        <dl class="cash-price">
                            <dd class="price text-primary lh-1">${formatCurrency(advert.price)}
                                <div class="d-flex align-items-center gap-1 ${!advert.location ? 'd-none' : ''}" style="margin-top: .5rem">
                                   <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.5081 14.1667C5.35254 14.1667 5.21921 14.1223 5.1081 14.0334C4.99699 13.9445 4.91365 13.8278 4.8581 13.6834C4.64699 13.0612 4.38032 12.4778 4.0581 11.9334C3.74699 11.3889 3.3081 10.75 2.74143 10.0167C2.17476 9.28337 1.71365 8.58337 1.3581 7.91671C1.01365 7.25004 0.841431 6.44448 0.841431 5.50004C0.841431 4.20004 1.29143 3.10004 2.19143 2.20004C3.10254 1.28893 4.2081 0.833374 5.5081 0.833374C6.8081 0.833374 7.9081 1.28893 8.8081 2.20004C9.71921 3.10004 10.1748 4.20004 10.1748 5.50004C10.1748 6.51115 9.98032 7.3556 9.59143 8.03337C9.21365 8.70004 8.77476 9.36115 8.27476 10.0167C7.67476 10.8167 7.21921 11.4834 6.9081 12.0167C6.6081 12.5389 6.3581 13.0945 6.1581 13.6834C6.10254 13.8389 6.01365 13.9612 5.89143 14.05C5.78032 14.1278 5.65254 14.1667 5.5081 14.1667ZM5.5081 7.16671C5.97476 7.16671 6.36921 7.0056 6.69143 6.68337C7.01365 6.36115 7.17476 5.96671 7.17476 5.50004C7.17476 5.03337 7.01365 4.63893 6.69143 4.31671C6.36921 3.99448 5.97476 3.83337 5.5081 3.83337C5.04143 3.83337 4.64699 3.99448 4.32476 4.31671C4.00254 4.63893 3.84143 5.03337 3.84143 5.50004C3.84143 5.96671 4.00254 6.36115 4.32476 6.68337C4.64699 7.0056 5.04143 7.16671 5.5081 7.16671Z"
                                        fill="#022935"/>
                                    </svg>
                                    <span>${advert.location?.name}</span>
                                </div>
                            </dd>
                        </dl>
                        <dl class="finance-price align-items-end">
                            <dd class="price lh-1" style="font-weight: 600">
                                ${formatCurrency(Math.round(advert.lowestMonthlyFinanceFrom.pence / 100))}<span>/month</span>
                            </dd>
                            <div class="d-inline-flex gap-1 align-items-center" data-show-representative-example="true" style="margin-top: .375rem">
                                <span class="text-decoration-underline" style="pointer-events: none;font-size: 10px">Example</span>
                                <svg width="11" height="11" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.60104 4.66501C8.59904 6.86627 6.82225 8.66535 4.59937 8.66401C2.39143 8.66267 0.602603 6.88053 0.603272 4.66301C0.60394 2.4428 2.40035 0.666685 4.60271 0.666016C6.80999 0.665347 8.60104 2.45774 8.60104 4.66501ZM5.29292 5.54092C5.29292 5.04801 5.29225 4.556 5.29359 4.06309C5.29426 3.87672 5.22782 3.71866 5.09027 3.59604C4.87336 3.40209 4.62122 3.36152 4.35058 3.45693C4.09242 3.54856 3.91942 3.79668 3.92076 4.07736C3.92633 5.05894 3.92366 6.04052 3.9221 7.0221C3.9221 7.57676 4.39739 7.67017 4.62456 7.6695C4.9661 7.66816 5.30184 7.39284 5.29493 6.9978C5.28623 6.51225 5.29292 6.02625 5.29292 5.54092ZM5.33974 2.3913C5.33907 1.982 5.01224 1.65584 4.60205 1.65584C4.1914 1.65584 3.86324 1.98467 3.86391 2.39532C3.86458 2.8015 4.19608 3.13234 4.60271 3.13234C5.01224 3.13234 5.33974 2.80284 5.33974 2.3913Z"
                                    fill="#022935"/>
                                </svg>
                            </div>
                        </dl>
                    </div>
                </div>
            </a>
      </div>
    `
}

function formatCurrency(number) {
    return new Intl.NumberFormat('en-UK', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0
    }).format(number)
}

function formatNumber(number) {
    return new Intl.NumberFormat('en-UK', {maximumFractionDigits: 0}).format(number)
}
